import React, { useEffect, useState } from 'react';
import { FaGem, FaStar, FaBuilding, FaLightbulb, FaComments, FaGhost } from 'react-icons/fa';
import UserDropdown from './UserDropdown';
import TourSpotlight from './TourSpotlight';
import NavbarNavModals from './NavbarNavModals';
import { promoHalloweenVigente } from './PromoHalloween';
import useAccesosPortal from '../hooks/useAccesosPortal';
import { nombrePlan, codigoPlanVisible } from './planPermissions';
import {
  Badge,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Card,
  CardBody,
  Row,
  Col
} from 'reactstrap';

const NavbarNav = ({ user = { plan: 'MENOR', name: 'Juan Pérez', email: 'juan@example.com', picture: null }, onLogout, onAbrirPromo, abrirPreferencias, onIniciarRecorrido }) => {
  // El catálogo de grupos del plan Curso: hace falta para saber a qué plan
  // equivale el curso del alumno (ver nombrePlan). Viene de un snapshot de
  // sesión, así que no cuesta una consulta por pantalla.
  const { grupos: gruposCurso } = useAccesosPortal();
  const [planesModalOpen, setPlanesModalOpen] = useState(false);
  const [testimoniosModalOpen, setTestimoniosModalOpen] = useState(false);
  const [conocenosModalOpen, setConocenosModalOpen] = useState(false);
  const [sugerenciasModalOpen, setSugerenciasModalOpen] = useState(false);
  const [sugerenciaForm, setSugerenciaForm] = useState({
    tipo: 'mejora',
    titulo: '',
    descripcion: '',

  });
  const [sugerenciaEnviada, setSugerenciaEnviada] = useState(false);
  const [pasoGuia, setPasoGuia] = useState(0);

  useEffect(() => {
    if (abrirPreferencias) setPasoGuia(1);
  }, [abrirPreferencias]);

  const iniciarRecorrido = () => {
    setPasoGuia(1);
    onIniciarRecorrido?.();
  };

  const togglePlanesModal = () => setPlanesModalOpen(!planesModalOpen);
  const toggleTestimoniosModal = () => setTestimoniosModalOpen(!testimoniosModalOpen);
  const toggleConocenosModal = () => setConocenosModalOpen(!conocenosModalOpen);
  const toggleSugerenciasModal = () => setSugerenciasModalOpen(!sugerenciasModalOpen);

  const getPlanDisplayName = (plan) => nombrePlan(plan, user?.curso_tipo, gruposCurso);
  // Para el color de la insignia manda el plan que se está mostrando: un alumno
  // del curso de contratos mayores ve «Plan Plus», y con el color del Plus.
  const planVisible = codigoPlanVisible(user?.plan, user?.curso_tipo, gruposCurso);

  const handleSolicitarUpgrade = (planDestino) => {
    const mensaje = `¡Hola! 👋

Espero que tengan un excelente día. Me comunico desde la plataforma de Nuvia Consulting para solicitar información sobre el upgrade a ${planDestino}.

📋 Información de mi cuenta:
• Usuario: ${user?.email}
• Plan actual: ${getPlanDisplayName(user?.plan)}
• Plan solicitado: ${planDestino}

Me gustaría conocer:
✅ Proceso de upgrade
✅ Formas de pago disponibles
✅ Tiempo de activación
✅ Beneficios adicionales

¡Muchas gracias por su atención! 🙏`;
    
    const whatsappUrl = `https://wa.me/51942128139?text=${encodeURIComponent(mensaje)}`;
    window.open(whatsappUrl, '_blank');
  };

  const handleRenovar = (plan) => {
    const mensaje = `Hola, quiero renovar mi membresía ${plan}. Mi correo es ${user?.email || ''}. ¿Me indican las opciones y formas de pago?`;
    window.open(`https://wa.me/51942128139?text=${encodeURIComponent(mensaje)}`, '_blank', 'noopener,noreferrer');
  };

  const handleContact = () => {
    const mensaje = `¡Hola! 👋

Me gustaría conocer más sobre Nuvia Consulting y sus servicios.

🏢 Estoy interesado en:
- Información general sobre la plataforma
- Planes disponibles
- Funcionalidades principales
- Proceso de registro

¡Espero su respuesta! 😊`;
    const whatsappUrl = `https://wa.me/51942128139?text=${encodeURIComponent(mensaje)}`;
    window.open(whatsappUrl, '_blank');

  };

  const handleSugerenciaSubmit = (e) => {
    e.preventDefault();
    
    const mensaje = `🎯 NUEVA SUGERENCIA - LicitaHUB

👤 Usuario: ${user?.name} (${user?.email})
📋 Plan: ${getPlanDisplayName(user?.plan)}

🔖 Tipo: ${sugerenciaForm.tipo.charAt(0).toUpperCase() + sugerenciaForm.tipo.slice(1)}

📝 Título: ${sugerenciaForm.titulo}

💭 Descripción:
${sugerenciaForm.descripcion}

---
Enviado desde la plataforma LicitaHUB
Fecha: ${new Date().toLocaleDateString('es-PE')}`;

    const whatsappUrl = `https://wa.me/51942128139?text=${encodeURIComponent(mensaje)}`;
    window.open(whatsappUrl, '_blank');
    
    setSugerenciaEnviada(true);
    setTimeout(() => {
      setSugerenciasModalOpen(false);
      setSugerenciaEnviada(false);
      setSugerenciaForm({
        tipo: 'mejora',
        titulo: '',
        descripcion: '',
  
      });
    }, 2000);
  };

  const testimonios = [
    {
      id: 1,
      nombre: "María García",
      empresa: "Ruc: 2060451****",
      cargo: "Gerente General",
      mensaje: "LicitaHUB transformó completamente nuestro proceso de búsqueda de oportunidades. En 2 meses nos hemos adjudicado en 3 contratos menores y 2 mayores. La plataforma es increíblemente intuitiva y las alertas personalizadas nos han permitido no perder ninguna oportunidad importante.",
      rating: 5,
      fecha: "28 Agosto 2025",
      plan: "Plan Plus",
      avatar: "👩‍💼",
      destacado: true
    },
    {
      id: 2,
      nombre: "Carlos Mendoza",
      empresa:  "Ruc: 2063881****",
      cargo: "Director Comercial",
      mensaje: "Como empresa de tecnología, necesitábamos una herramienta que nos mantuviera actualizados con todas las licitaciones del sector público. LicitaHUB no solo cumplió nuestras expectativas, sino que las superó. El filtrado inteligente nos ahorra horas de trabajo cada semana.",
      rating: 5,
      fecha: "20 Agosto 2025",
      plan: "Plan Plus",
      avatar: "👨‍💻"
    },
    {
      id: 3,
      nombre: "Ana Rodríguez",
      empresa: "Ruc: 107294*****",
      cargo: "Gerente General",
      mensaje: "Empezamos hace poco en las licitaciones LicitaHub nos ayudó a encontrar y adjudicarnos 3 procesos menores a 8 UIT. Definitivamente recomiendo la plataforma a cualquier empresa que quiera comenzar a licitar.",
      rating: 5,
      fecha: "18 Agosto 2025",
      plan: "Plan Básico",
      avatar: "👩‍⚕️"
    },
    {
      id: 4,
      nombre: "Roberto Silva",
      empresa: "Ruc: 102249******",
      cargo: "Socio Fundador",
      mensaje: "Super útil las alertas que llegan al correo, siempre estamos al tanto con los procesos menores que se van publicando ahorrando mucho tiempo y trabajo",
      rating: 5,
      fecha: "16 Agosto 2025",
      plan: "Plan Básico",
      avatar: "👨‍💼"
    },
    {
      id: 5,
      nombre: "Patricia Vega",
      empresa: "Ruc: 2054816****",
      cargo: "Gerente de Ventas",
      mensaje: "Este sistema es realmente útil, podemos ver todos los procesos vigentes mayores ahorrandonos tiempo y nos adjudicamos un procceso de 400k soles en menos de 2 meses usando está herramienta",
      rating: 5,
      fecha: "15 Agosto 2025",
      plan: "Plan Plus",
      avatar: "👨‍💼"
    },
    {
      id: 6,
      nombre: "Diego Fernández",
      empresa: "Ruc: 206525*****",
      cargo: "Gerente de Proyectos",
      mensaje: "Lo que más me gusta de LicitaHUB es la información actualizada y disponible. Podemos competir de igual a igual con las grandes empresas porque tenemos acceso oportuno a la información.",
      rating: 5,
      fecha: "20 Julio 2025",
      plan: "Plan Plus",
      avatar: "👨‍🔧"
    }
  ];

  // Estilos del navbar depurado (opción 3a: logo sólido, ítems planos, un solo CTA)
  const navItemStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: 7,
    padding: '8px 12px',
    borderRadius: 8,
    color: '#3f4b60',
    fontSize: 13.5,
    fontWeight: 500,
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    fontFamily: 'inherit',
    whiteSpace: 'nowrap'
  };

  const ctaComunidadStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: 7,
    padding: '8px 13px',
    borderRadius: 8,
    marginLeft: 6,
    border: '1px solid #cfe6dd',
    background: '#f1f9f6',
    color: '#0f4f47',
    fontSize: 13.5,
    fontWeight: 600,
    textDecoration: 'none',
    whiteSpace: 'nowrap'
  };

  const planPillStyle = (plan) => {
    const p = (plan || '').toUpperCase();
    let color = '#3f4b60', background = '#eef1f5', borderColor = '#e0e5ec';
    if (p === 'ADMI') {
      color = '#0f4f47'; background = '#e4f3ee'; borderColor = '#cfe6dd';
    } else if (p === 'PREMIUM' || p === 'PLUS_PLUS') {
      color = '#8a6412'; background = '#fdf7e7'; borderColor = '#f0e2bd';
    }
    return {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 6,
      fontSize: 11.5,
      fontWeight: 600,
      letterSpacing: '.04em',
      textTransform: 'uppercase',
      color,
      background,
      border: `1px solid ${borderColor}`,
      padding: '5px 11px',
      borderRadius: 6,
      whiteSpace: 'nowrap'
    };
  };

  // Naranja de la campaña de Halloween: el único color caliente de la barra,
  // justamente para que se despegue del resto.
  const promoBtnStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    padding: '8px 15px',
    borderRadius: 999,
    border: 0,
    background: '#f28c28',
    color: '#0b1f1c',
    fontSize: 13.5,
    fontWeight: 800,
    whiteSpace: 'nowrap',
    cursor: 'pointer'
  };

  // El botón vive mientras viva la oferta: al vencer desaparece solo.
  const promoVisible = Boolean(onAbrirPromo) && promoHalloweenVigente();

  const comunidadUrl = 'https://chat.whatsapp.com/K4HtjEeHbSIFu8A4typjuE';

  return (
    <>

      {/* ===== Navbar depurado (desktop) ===== */}
      <div
        className="d-none d-lg-flex nav-bar-enter"
        style={{
          alignItems: "center",
          gap: 26,
          padding: "12px 24px",
          background: "#fff",
          borderBottom: "1px solid #e4e8ee",
          position: "relative",
          zIndex: 1050
        }}
      >
        {/* Marca */}
        <div style={{ display: "flex", alignItems: "center", gap: 12, flexShrink: 0 }}>
          <img className="nav-logo" src="/nuvia-200x200.jpg" alt="LicitaHUB" style={{ width: 38, height: 38, borderRadius: 10, objectFit: "cover", boxShadow: "0 2px 8px rgba(15,79,71,.28)", flexShrink: 0 }} />
          <div>
            <div style={{ fontSize: 16, fontWeight: 700, color: "#0f172a", letterSpacing: "-0.02em", lineHeight: 1.15 }}>Nuvia Consulting</div>
            <div style={{ fontSize: 11, color: "#5b6779", lineHeight: 1.3 }}>Porta1l de contrataciones</div>
          </div>
        </div>

        {/* Divisor */}
        <div style={{ width: 1, height: 26, background: "#e8ebf0", flexShrink: 0 }} />

        {/* Navegación */}
        <div style={{ display: "flex", alignItems: "center", gap: 2, minWidth: 0, flex: 1 }}>
          <button type="button" onClick={togglePlanesModal} className="nav-item-flat" style={navItemStyle}>
            <FaGem style={{ fontSize: 16, color: "#7b8798" }} /><span>Planes</span>
          </button>
          <button type="button" onClick={toggleConocenosModal} className="nav-item-flat" style={navItemStyle}>
            <FaBuilding style={{ fontSize: 16, color: "#7b8798" }} /><span>Conócenos</span>
          </button>
          <button type="button" onClick={toggleSugerenciasModal} className="nav-item-flat" style={navItemStyle}>
            <FaLightbulb style={{ fontSize: 16, color: "#7b8798" }} /><span>Sugerencias</span>
          </button>
          <a href={comunidadUrl} target="_blank" rel="noopener noreferrer" className="nav-cta-comunidad" style={ctaComunidadStyle}>
            <FaComments style={{ fontSize: 16, color: "#0f766e" }} /><span>Comunidad</span>
          </a>
        </div>

        {/* Acciones */}
        <div style={{ display: "flex", alignItems: "center", gap: 14, flexShrink: 0 }}>
          {promoVisible && (
            <button
              type="button"
              className="nav-promo"
              style={promoBtnStyle}
              onClick={onAbrirPromo}
              aria-label="Ver la promoción de Halloween"
            >
              <FaGhost style={{ fontSize: 16 }} />
              <span>Promo 50% OFF</span>
            </button>
          )}
          <button type="button" onClick={iniciarRecorrido} aria-label="Personaliza las alertas" title="Personaliza las alertas" style={{ display: 'inline-flex', alignItems: 'center', gap: 7, border: '1px solid #cfe6dd', background: '#f1f9f6', color: '#0f766e', borderRadius: 10, padding: '8px 11px', fontWeight: 650, fontSize: 13, cursor: 'pointer', whiteSpace: 'nowrap' }}>
            <FaLightbulb style={{ fontSize: 15 }} /><span>Personaliza las alertas</span>
          </button>
          <span style={planPillStyle(planVisible)}>
            <span style={{ width: 6, height: 6, borderRadius: "50%", background: "currentColor", flexShrink: 0 }} />
            {getPlanDisplayName(user?.plan)}
          </span>
          <UserDropdown user={user} onLogout={onLogout} onOpenPlans={() => setPlanesModalOpen(true)} onRenew={handleRenovar} pasoGuia={pasoGuia} onAbrirMenuGuiado={() => setPasoGuia(2)} onAbrirPreferenciasGuiadas={() => setPasoGuia(3)} onTerminarRecorrido={() => setPasoGuia(0)} />
        </div>
      </div>

      {pasoGuia === 1 && <TourSpotlight selector=".nuvia-account-toggle" step={1} title="Haz clic aquí">Abre tu menú haciendo clic en tu nombre o avatar. Las opciones aparecerán aquí.</TourSpotlight>}
      {pasoGuia === 2 && <TourSpotlight selector=".nuvia-guide-preferences" step={2} title="Abre Preferencias">Haz clic en esta opción para elegir tus alertas y filtros.</TourSpotlight>}

      {/* ===== Navbar depurado (móvil) ===== */}
      <div
        className="d-flex d-lg-none nav-bar-enter"
        style={{
          alignItems: "center",
          gap: 10,
          padding: "11px 14px",
          background: "#fff",
          borderBottom: "1px solid #e4e8ee",
          position: "relative",
          zIndex: 1050
        }}
      >
        <img className="nav-logo" src="/nuvia-200x200.jpg" alt="LicitaHUB" style={{ width: 32, height: 32, borderRadius: 8, objectFit: "cover", boxShadow: "0 2px 8px rgba(15,79,71,.28)", flexShrink: 0 }} />
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: 15, fontWeight: 700, color: "#0f172a", letterSpacing: "-0.02em", lineHeight: 1.2 }}>Nuvia Consulting</div>
          <div style={{ fontSize: 11, color: "#5b6779", lineHeight: 1.3 }}>Portal de contrataciones</div>
        </div>
        <span style={{ ...planPillStyle(planVisible), fontSize: 10.5, padding: "4px 8px" }}>
          <span style={{ width: 5, height: 5, borderRadius: "50%", background: "currentColor", flexShrink: 0 }} />
          {getPlanDisplayName(user?.plan)}
        </span>
        {promoVisible && (
          <button
            type="button"
            className="nav-promo"
            onClick={onAbrirPromo}
            title="Promoción de Halloween · 50% OFF"
            aria-label="Ver la promoción de Halloween"
            style={{ ...promoBtnStyle, width: 34, height: 34, padding: 0, borderRadius: 10, justifyContent: "center", flexShrink: 0 }}
          >
            <FaGhost style={{ fontSize: 16 }} />
          </button>
        )}
        <button type="button" onClick={iniciarRecorrido} aria-label="Personaliza las alertas" title="Personaliza las alertas" style={{ width: 34, height: 34, border: '1px solid #cfe6dd', background: '#f1f9f6', color: '#0f766e', borderRadius: 10, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, cursor: 'pointer' }}>
          <FaLightbulb style={{ fontSize: 15 }} />
        </button>
        <a
          href={comunidadUrl}
          target="_blank"
          rel="noopener noreferrer"
          title="Únete a nuestra comunidad"
          style={{ width: 34, height: 34, borderRadius: 8, border: "1px solid #cfe6dd", background: "#f1f9f6", color: "#0f766e", display: "flex", alignItems: "center", justifyContent: "center", textDecoration: "none", flexShrink: 0 }}
        >
          <FaComments style={{ fontSize: 16 }} />
        </a>
        <UserDropdown user={user} onLogout={onLogout} onOpenPlans={() => setPlanesModalOpen(true)} onRenew={handleRenovar} pasoGuia={pasoGuia} onAbrirMenuGuiado={() => setPasoGuia(2)} onAbrirPreferenciasGuiadas={() => setPasoGuia(3)} onTerminarRecorrido={() => setPasoGuia(0)} />
      </div>

      <NavbarNavModals
        {...{ user, getPlanDisplayName, planVisible, planesModalOpen, togglePlanesModal,
          conocenosModalOpen, toggleConocenosModal, sugerenciasModalOpen, toggleSugerenciasModal,
          sugerenciaForm, setSugerenciaForm, sugerenciaEnviada, handleSugerenciaSubmit,
          handleSolicitarUpgrade, handleContact, comunidadUrl }}
      />

      {/* Modal de Testimonios */}
      <Modal isOpen={testimoniosModalOpen} toggle={toggleTestimoniosModal} size="xl">
        <ModalHeader toggle={toggleTestimoniosModal} style={{ 
          background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)', 
          color: 'white',
          border: 'none',
          padding: '24px 32px'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <FaStar style={{ fontSize: '1.5rem' }} />
            <h4 className="mb-0" style={{ fontWeight: '700' }}>Testimonios de Nuestros Clientes</h4>
          </div>
        </ModalHeader>
        <ModalBody style={{ padding: '2rem' }}>
          <div className="text-center mb-4">
            <p style={{ color: '#718096', fontSize: '1.1rem' }}>
              Descubre lo que dicen nuestros clientes sobre LicitaHUB y cómo hemos transformado sus negocios
            </p>
            <div style={{ 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center', 
              gap: '8px',
              marginTop: '16px'
            }}>
              <div style={{ display: 'flex', gap: '4px' }}>
                {[1,2,3,4,5].map(star => (
                  <FaStar key={star} style={{ color: '#fbbf24', fontSize: '1.5rem' }} />
                ))}
              </div>
              <span style={{ 
                fontSize: '1.2rem', 
                fontWeight: '700', 
                color: '#2d3748', 
                marginLeft: '12px' 
              }}>
                4.9/5
              </span>
              <span style={{ color: '#718096', marginLeft: '8px' }}>
                (Promedio de {testimonios.length} reseñas)
              </span>
            </div>
          </div>

          <Row>
            {testimonios.map((testimonio) => (
              <Col lg={6} key={testimonio.id} className="mb-4">
                <Card style={{ 
                  border: 'none', 
                  boxShadow: testimonio.destacado ? '0 8px 25px rgba(245, 158, 11, 0.2)' : '0 4px 15px rgba(0,0,0,0.08)',
                  borderRadius: '20px',
                  height: '100%',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                  position: 'relative',
                  border: testimonio.destacado ? '2px solid #fbbf24' : '1px solid #e2e8f0'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = testimonio.destacado ? '0 12px 30px rgba(245, 158, 11, 0.3)' : '0 8px 25px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = testimonio.destacado ? '0 8px 25px rgba(245, 158, 11, 0.2)' : '0 4px 15px rgba(0,0,0,0.08)';
                }}>
                  {testimonio.destacado && (
                    <div style={{
                      position: 'absolute',
                      top: '-12px',
                      left: '20px',
                      background: 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)',
                      color: 'white',
                      padding: '6px 16px',
                      borderRadius: '20px',
                      fontSize: '0.8rem',
                      fontWeight: '700'
                    }}>
                      ⭐ DESTACADO
                    </div>
                  )}
                  <CardBody style={{ padding: '2rem' }}>
                    <div className="d-flex align-items-start mb-3">
                      <div style={{
                        width: '60px',
                        height: '60px',
                        borderRadius: '50%',
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '1.8rem',
                        marginRight: '16px',
                        boxShadow: '0 4px 15px rgba(102, 126, 234, 0.3)'
                      }}>
                        {testimonio.avatar}
                      </div>
                      <div style={{ flex: 1 }}>
                        <h6 style={{ 
                          color: '#2d3748', 
                          fontWeight: '700',
                          marginBottom: '4px'
                        }}>
                          {testimonio.nombre}
                        </h6>
                        <p style={{ 
                          color: '#4a5568', 
                          fontSize: '0.9rem',
                          marginBottom: '4px',
                          fontWeight: '600'
                        }}>
                          {testimonio.cargo}
                        </p>
                        <p style={{ 
                          color: '#718096', 
                          fontSize: '0.85rem',
                          marginBottom: '8px'
                        }}>
                          {testimonio.empresa}
                        </p>
                        <div className="d-flex align-items-center gap-2">
                          <Badge 
                            color={testimonio.plan === 'Plan Plus' ? 'warning' : testimonio.plan === 'Plan Pro' ? 'info' : 'secondary'}
                            pill
                            style={{ fontSize: '0.7rem', padding: '4px 10px' }}
                          >
                            {testimonio.plan}
                          </Badge>
                          <div style={{ display: 'flex', gap: '2px' }}>
                            {[1,2,3,4,5].map(star => (
                              <FaStar 
                                key={star} 
                                style={{ 
                                  color: star <= testimonio.rating ? '#fbbf24' : '#e2e8f0', 
                                  fontSize: '0.9rem' 
                                }} 
                              />
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <div style={{
                      background: 'linear-gradient(135deg, #f8fafc 0%, #edf2f7 100%)',
                      padding: '1.5rem',
                      borderRadius: '12px',
                      marginBottom: '16px',
                      border: '1px solid #e2e8f0',
                      position: 'relative'
                    }}>
                      <div style={{
                        position: 'absolute',
                        top: '-8px',
                        left: '20px',
                        width: '16px',
                        height: '16px',
                        background: 'linear-gradient(135deg, #f8fafc 0%, #edf2f7 100%)',
                        transform: 'rotate(45deg)',
                        border: '1px solid #e2e8f0',
                        borderBottom: 'none',
                        borderRight: 'none'
                      }}></div>
                      <p style={{ 
                        color: '#4a5568', 
                        fontSize: '0.95rem',
                        lineHeight: '1.6',
                        marginBottom: '0',
                        fontStyle: 'italic'
                      }}>
                        "{testimonio.mensaje}"
                      </p>
                    </div>
                    
                    <div className="d-flex justify-content-between align-items-center">
                      <small style={{ 
                        color: '#a0aec0', 
                        fontWeight: '500'
                      }}>
                        📅 {testimonio.fecha}
                      </small>
                      <div style={{ 
                        color: '#22c55e',
                        fontSize: '0.9rem',
                        fontWeight: '600',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px'
                      }}>
                        ✓ Cliente verificado
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>

          <div className="text-center mt-5">
            <div style={{
              background: 'linear-gradient(135deg, #f7fafc 0%, #edf2f7 100%)',
              padding: '2rem',
              borderRadius: '20px',
              border: '1px solid #e2e8f0'
            }}>
              <h5 style={{ color: '#2d3748', fontWeight: '700', marginBottom: '16px' }}>
                ¿Quieres ser parte de estas historias de éxito?
              </h5>
              <p style={{ color: '#718096', marginBottom: '24px' }}>
                Únete a más de 400 empresas que ya confían en LicitaHUB para encontrar oportunidades de negocio
              </p>
              <Button 
                color="warning"
                onClick={() => {
                  const mensaje = `¡Hola! 👋

He visto los testimonios de sus clientes y me interesa conocer más sobre LicitaHUB.

🎯 Me gustaría información sobre:
- Planes disponibles y precios
- Proceso de registro
- Demo de la plataforma
- Funcionalidades principales

📧 Mi email: ${user?.email}

¡Espero su respuesta! 😊`;
                  const whatsappUrl = `https://wa.me/51942128139?text=${encodeURIComponent(mensaje)}`;
                  window.open(whatsappUrl, '_blank');
                }}
                style={{
                  borderRadius: '30px',
                  padding: '12px 30px',
                  fontWeight: '600',
                  background: 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)',
                  border: 'none',
                  boxShadow: '0 4px 15px rgba(251, 191, 36, 0.3)'
                }}
              >
                <span style={{ marginRight: '8px' }}>🚀</span>
                Comenzar mi historia de éxito
              </Button>
            </div>
          </div>
        </ModalBody>
      </Modal>

      <style>
        {`
          .nav-item-flat {
            transition: background .18s ease, color .18s ease;
          }
          .nav-item-flat svg {
            transition: color .18s ease, transform .18s ease;
          }
          .nav-item-flat:hover {
            background: #f3f5f8 !important;
            color: #0f172a !important;
          }
          .nav-item-flat:hover svg {
            color: #0f766e !important;
            transform: translateY(-1px);
          }
          .nav-item-flat:active {
            background: #eaeef3 !important;
          }

          .nav-cta-comunidad {
            transition: background .18s ease, box-shadow .18s ease, transform .18s ease;
          }
          .nav-cta-comunidad:hover {
            background: #e4f3ee !important;
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(15,118,110,.18);
          }
          .nav-cta-comunidad:active {
            transform: translateY(0);
            box-shadow: 0 2px 6px rgba(15,118,110,.15);
          }

          .nav-promo {
            transition: background .18s ease, transform .18s ease;
            animation: navPromoLatido 2.2s ease-out infinite;
          }
          .nav-promo:hover {
            background: #ffa241 !important;
            transform: translateY(-1px);
          }
          .nav-promo:active {
            transform: translateY(0);
          }
          .nav-promo svg {
            animation: navPromoFlota 3s ease-in-out infinite;
          }

          @keyframes navPromoLatido {
            0%, 100% { box-shadow: 0 0 0 0 rgba(242,140,40,.55); }
            70%      { box-shadow: 0 0 0 12px rgba(242,140,40,0); }
          }

          @keyframes navPromoFlota {
            0%, 100% { transform: translateY(0); }
            50%      { transform: translateY(-2px); }
          }

          @media (prefers-reduced-motion: reduce) {
            .nav-promo, .nav-promo svg { animation: none; }
          }

          .nav-logo {
            transition: transform .2s ease, box-shadow .2s ease;
          }
          .nav-logo:hover {
            transform: scale(1.05);
            box-shadow: 0 4px 14px rgba(15,79,71,.34) !important;
          }

          .nav-bar-enter {
            animation: navFadeDown .5s ease both;
          }

          @keyframes navFadeDown {
            from { opacity: 0; transform: translateY(-10px); }
            to   { opacity: 1; transform: translateY(0); }
          }

          @keyframes pulse {
            0% {
              transform: scale(1);
            }
            50% {
              transform: scale(1.1);
            }
            100% {
              transform: scale(1);
            }
          }

          @keyframes bounce {
            0%, 20%, 50%, 80%, 100% {
              transform: translateY(0);
            }
            40% {
              transform: translateY(-10px);
            }
            60% {
              transform: translateY(-5px);
            }
          }
        `}
      </style>
    </>
  );
};

export default NavbarNav;
